import { Component, OnInit, Input } from '@angular/core';
import { NgFor } from '@angular/common';
import { OrderByPipe } from '../../../pipes/order-by/order-by.pipe';

@Component({
    selector: 'app-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrls: ['./tooltip.component.scss'],
    imports: [NgFor, OrderByPipe]
})
export class TooltipComponent implements OnInit {
  @Input() tooltipId:string=""
  @Input() title: string = "";
  @Input() data: any = []
  ngOnInit(): void {

  }
}
